const mainContainer = $('.imagesect__mainimagecontainer');
const thumbnails = $('.thumbnail__container');

function getCookie(name) {
  let result = document.cookie.match(new RegExp(name + '=([^=;]+)?'));
  return result && result[1];
}

function updateMainContainer(thumbnail) {
  const newPicture = thumbnail.clone();
  mainContainer.empty().append(newPicture);
}

if (thumbnails.length > 1) {
  thumbnails.each(function () {
    const thumbnail = $(this);

    thumbnail.on('click', function () {
      thumbnails.removeClass('thumbnail__container--active thumbnail__container--hover');
      thumbnail.addClass('thumbnail__container--active');
      updateMainContainer(thumbnail);
    });
  });
}

const addButton = document.getElementById('cartbox__controller--add');
const restButton = document.getElementById('cartbox__controller--rest');
const quantitySpan = document.querySelector('.cartbox__quantity');
const updateButton = document.querySelector('.cartbox__update');
const buttonUpdateText = document.getElementById('update__text');
const productId = parseInt(document.getElementById('productId').value, 10);
const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
const loader = document.getElementById('update-loader');
const cartQuantity = document.querySelector('.ecomcartwrappe__quantity');
const cartWrapper = document.querySelector('.nhead__ecomcartwrapper');
const itemQuantityHolder = document.querySelector('.cartbox__quantity');

let actualQuantity = parseInt(quantitySpan.textContent.trim(), 10);

let cartData = getCookie("cart_items");

if (cartData && itemQuantityHolder) {
  cartData = JSON.parse(decodeURIComponent(cartData));
  itemQuantityHolder.innerText = cartData[productId] ?? 0;
  if (cartData[productId] > 0) {
    buttonUpdateText.innerText = buttonUpdateText.dataset.basketUpdate
  }
} else {
  itemQuantityHolder.innerText = 0;
}

function updateQuantity(amount) {
  let currentQuantity = parseInt(quantitySpan.textContent, 10) || 0;
  currentQuantity = Math.max(0, currentQuantity + amount);
  quantitySpan.textContent = currentQuantity;
}

addButton.addEventListener('click', (event) => {
  event.preventDefault();
  updateQuantity(1);
});

restButton.addEventListener('click', (event) => {
  event.preventDefault();
  updateQuantity(-1);
});

updateButton.addEventListener('click', (event) => {
  event.preventDefault();
  let newQuantity = parseInt(quantitySpan.textContent.trim(), 10);
  if (actualQuantity !== newQuantity || (actualQuantity === 0 && newQuantity === 0)) {
    loader.classList.toggle('d__none');
    buttonUpdateText.innerText = '';
    fetch(`/shoppingcart/setquantity/0/${productId}?quantity=${cartData && !cartData[productId] && newQuantity === 0 ? 1 : newQuantity}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-SecurityID': csrfToken,
      },
    }).then(response => response.json())
      .then(data => {
        cartWrapper.classList.remove('nhead__ecomcartwrapper--hide');
        updateButton.disabled = false;
        addButton.disabled = false;
        restButton.disabled = false;
        actualQuantity = data.quantity
        loader.classList.toggle('d__none');
        itemQuantityHolder.innerHTML = data.quantity;
        if (data.quantity === 0) {
          buttonUpdateText.innerText = buttonUpdateText.dataset.basketAdd
        } else {
          buttonUpdateText.innerText = buttonUpdateText.dataset.basketUpdate
        }
        cartQuantity.classList.add('ecomcartwrappe__quantity--updated');
        setTimeout(() => {
          cartQuantity.classList.remove('ecomcartwrappe__quantity--updated');
        }, 600);
        cartQuantity.innerText = data.total_items
        cartData[productId] = data.quantity;
      });
  }
});

const relatedProducts = document.querySelectorAll('.relprod__item');

relatedProducts.forEach(item => {
  item.addEventListener('click', event => {
    event.preventDefault();
    const reletedProductId = item.dataset.productid;
    const isInCart = item.classList.contains('relprod__item--incart');

    fetch(`/shoppingcart/setquantity/0/${reletedProductId}?quantity=${isInCart ? 0 : 1}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-SecurityID': csrfToken,
      },
    }).then(response => response.json())
      .then(data => {
        cartWrapper.classList.remove('nhead__ecomcartwrapper--hide');
        cartQuantity.classList.add('ecomcartwrappe__quantity--updated');
        setTimeout(() => {
          cartQuantity.classList.remove('ecomcartwrappe__quantity--updated');
        }, 600);
        cartQuantity.innerText = data.total_items
        cartData[reletedProductId] = data.quantity;
        item.classList.toggle('relprod__item--incart', !isInCart);
      });
  });
});
